// extracted by mini-css-extract-plugin
export default {"wrapper":"SmallMenu_wrapper__2Iuh+","body":"SmallMenu_body__4EZAk","open":"SmallMenu_open__7dGLT","close":"SmallMenu_close__ut-WJ"};